import { render, staticRenderFns } from "./TBadge.vue?vue&type=template&id=7abad128"
import script from "./TBadge.vue?vue&type=script&lang=js"
export * from "./TBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports